module.exports = __webpack_public_path__ + "static/media/7 (1).e5b14980.webp";